<template>
    <div class="is-grow-1 mt-4">
        <search-bar :onSearch="debouncedOnSearch" class="mb-4 mt-2" />

        <b-collapse class="card" :open="false" animation="slide">
            <div slot="trigger" slot-scope="props" class="card-header is-paddingless">
                <div class="card-header-title">
                    <div class="filtro-header">
                        <b-icon :icon="props.open ? 'menu-down' : 'menu-right'"></b-icon>
                        {{ $t('filtros') }}
                    </div>
                </div>
            </div>
            <div class="card-content">
                <div class="columns is-multiline card-content-section">
                    <div class="column is-one-half is-full-mobile filtro">
                        <VerifiedLable title="atividade"/>
                        <s-select
                            :value="atividadesSelecionadas"
                            :options="atividades"
                            :selectHeight="40"
                            :loading="atividadesLoading"
                            @search="carregarAtividades"
                            @input="updateAtividade"
                            label="descricao"
                            multiple
                            searchable
                            clearable
                        />
                    </div>
                    <div class="column is-one-half is-full-mobile filtro">
                        <VerifiedLable title="situacao"/>
                        <s-select
                            :value="situacoesSelecionadas"
                            :options="situacoes"
                            :selectHeight="40"
                            :loading="situacoesLoading"
                            @search="carregarSituacoes"
                            @input="updateSituacao"
                            label="descricao"
                            multiple
                            searchable
                            clearable
                        />
                    </div>
                    <div class="column is-one-half is-full-mobile filtro">
                        <VerifiedLable title="cidade"/>
                        <s-select
                            :value="cidadesSelecionadas"
                            :options="cidades"
                            :selectHeight="40"
                            :loading="cidadesLoading"
                            @search="carregarCidades"
                            @input="updateCidade"
                            label="descricao"
                            multiple
                            searchable
                            clearable
                        />
                    </div>
                    <div class="column is-one-half is-full-mobile filtro">
                        <VerifiedLable title="regiao"/>
                        <s-select
                            :value="regioesSelecionadas"
                            :options="regioes"
                            :selectHeight="40"
                            :loading="regioesLoading"
                            @search="carregarRegioes"
                            @input="updateRegiao"
                            label="descricao"
                            multiple
                            searchable
                            clearable
                        />
                    </div>
                </div>
            </div>
        </b-collapse>

        <!-- BOTÕES -->
        <div class="columns mt-0 mb-2 is-flex is-flex-hcenter">
            <div class="column is-3 has-text-centered">
                <button class="save-btn pl-4 pr-4" @click="pesquisar">
                    {{ $t('pesquisar') }}
                </button>
            </div>
            <div class="column is-3 has-text-centered">
                <button class="delete-btn pl-4 pr-4" @click="confirmCleanFilters">
                    {{ $t('limpar-filtros') }}
                </button>
            </div>
            <div v-show="!assRotaClienteIntegracao" class="column is-3 has-text-centered">
                <button class="delete-btn pl-4 pr-4" @click="confirmAddAllToRoute">
                    {{ $t('adicionar-todos-rota') }}
                </button>
            </div>
            <div v-show="!assRotaClienteIntegracao" class="column is-3 has-text-centered">
                <button class="delete-btn pl-4 pr-4" @click="confirmRemoveAllFromRoute">
                    {{ $t('remover-todos-rota') }}
                </button>
            </div>
        </div>

        <div class="registry-wrapper">
            <b-table
                class="data-table in-page"
                :data="tableData"
                height="calc(100vh - 445px)"
                sticky-header
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    class="td-center"
                    :key="i"
                    :field="f.key"
                    :label="f.label != '' ? $t(f.label) : ''"
                    :width="f.width"
                    :centered="f.centered"
                    :sortable="f.sortable"
                    v-slot="props"
                >
                    <div v-if="f.key == 'ordem'">
                        <span v-if="props.row.inRoute && !assRotaClienteIntegracao">
                            {{ props.row[f.key] }}
                        </span>
                        <span v-else>–</span>
                    </div>
                    <div v-else-if="f.key == 'periodoDia'">
                        <s-select
                            v-if="props.row.inRoute && !assRotaClienteIntegracao"
                            :value="periodoOptions.find((e) => e.value == props.row.periodoDia)"
                            :options="periodoOptions"
                            @input="changePeriodo($event, props.row)"
                            useML
                        />
                        <span v-else>–</span>
                    </div>
                    <div v-else-if="f.key == 'rsocial'" class="is-flex is-flex-vcenter">
                        <b-icon
                            v-if="!(props.row.latitude && props.row.longitude)"
                            icon="map-marker-off"
                            type="is-dark"
                            class="mr-2"
                            v-tippy
                            :title="$t('msg-cliente-sem-localizacao')"
                        />
                        {{ props.row.rsocial }}
                    </div>
                    <div v-else-if="f.key == 'observacao'">
                        <v-input
                            v-if="props.row.inRoute && !assRotaClienteIntegracao"
                            :value="props.row.observacao"
                            @input="changeObservacao($event, props.row)"
                            :max-length="255"
                            no-clearfix
                        />
                    </div>
                    <div v-show="!assRotaClienteIntegracao" v-else-if="f.key == 'actions'">
                        <b-button
                            v-if="props.row.inRoute"
                            type="is-danger"
                            icon-right="delete"
                            @click="removeCliente(props.row.idcliente)"
                        />
                        <b-button
                            v-else
                            type="is-primary"
                            icon-right="plus"
                            @click="addOneToRoute(props.row.idcliente)"
                        />
                    </div>
                    <div v-else>
                        {{ props.row[f.key] }}
                    </div>
                </b-table-column>
            </b-table>

            <PaginationViewer
                :totalItems="totalRows"
                :perPageOptions="pagination.perPageOptions"
                @change="updatePagination"
            />
        </div>
    </div>
</template>

<script>
import AtividadeService from '@/services/AtividadeService';
import SituacaoService from '@/services/SituacaoService';
import CidadeService from '@/services/CidadeService';
import RegiaoService from '@/services/RegiaoService';
import VerifiedLable from '@/components/shared/VerifiedLable.vue';

export default {
    components: {
        VerifiedLable,
    },
    props: {
        rota: {
            /* {idrotavisita, cliente, ordem, periododia, observacao} */
            type: Array,
            default: () => [],
        },
        clientes: {
            /* {idcliente, nome, rsocial, cnpjcpf, ierg, endereco, latitude, longitude} */
            type: Array,
            default: () => [],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        totalRows: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            assRotaClienteIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'ASSROTAVISITACLIENTE'
            ),
            atividadeService: new AtividadeService(this.$http, this.$router),
            situacaoService: new SituacaoService(this.$http, this.$router),
            cidadeService: new CidadeService(this.$http, this.$router),
            regiaoService: new RegiaoService(this.$http, this.$router),
            query: '',
            currentPage: 1,
            fields: [
                { key: 'ordem', label: 'ordem', width: 100, centered: true, sortable: false },
                {
                    key: 'periodoDia',
                    label: 'periodo',
                    width: 200,
                    centered: true,
                    sortable: false,
                },
                { key: 'rsocial', label: 'cliente', sortable: false },
                { key: 'observacao', label: 'observacao', width: '30%', sortable: false },
                { key: 'actions', label: '', width: 40, sortable: false },
            ],
            periodoOptions: [
                { value: 0, label: 'manha' },
                { value: 1, label: 'tarde' },
                { value: 2, label: 'noite' },
            ],
            atividades: [],
            atividadesSelecionadas: [],
            atividadesLoading: false,
            situacoes: [],
            situacoesSelecionadas: [],
            situacoesLoading: false,
            cidades: [],
            cidadesSelecionadas: [],
            cidadesLoading: false,
            regioes: [],
            regioesSelecionadas: [],
            regioesLoading: false,
            pagination: {
                perPageOptions: [10, 25, 50, 100],
                currentPage: 1,
                perPage: 10,
                totalRows: 0,
            },
            debouncedOnSearch: null,
            clientesFora: [],
        };
    },

    created() {
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.$emit('updateList', this.pesquisar);
    },

    computed: {
        tableData() {
            /*
                Mapeia os clientes e coloca as informações de rota se eles estiverem
                inclusos na rota.

                Ordena eles de forma que os clientes na rota apareçam por primeiro e na
                ordem correta da sequência numérica.

                É feito o sort no front e no back, pois pode-se adicionar novos clientes
                a rota sem passar pela pesquisa no server, então isso mantém a ordem coreta.
            */
            return this.clientes
                .map((c) => {
                    let index = this.rota.findIndex((r) => r.cliente.idcliente == c.idcliente);

                    if (index > -1) {
                        let rota = this.rota[index];

                        return {
                            idcliente: c.idcliente,
                            nome: c.nome,
                            rsocial: c.rsocial,
                            cnpjcpf: c.cnpjcpf,
                            latitude: c.latitude,
                            longitude: c.longitude,
                            inRoute: true,
                            idrotavisita: rota.idrotavisita,
                            ordem: index + 1,
                            periodoDia: rota.periodoDia,
                            observacao: rota.observacao,
                        };
                    } else {
                        return {
                            idcliente: c.idcliente,
                            nome: c.nome,
                            rsocial: c.rsocial,
                            cnpjcpf: c.cnpjcpf,
                            latitude: c.latitude,
                            longitude: c.longitude,
                            inRoute: false,
                        };
                    }
                })
                .sort((a, b) => {
                    if (a.ordem != undefined && b.ordem != undefined) {
                        return a.ordem - b.ordem;
                    } else if (a.ordem != undefined) {
                        return -1;
                    } else {
                        return 1;
                    }
                });
        },
    },
    methods: {
        onSearch(value) {
            this.pagination.search = value;
            this.pesquisar();
        },
        changePeriodo(periodo, cliente) {
            this.$emit('change-periodo', {
                periodo: periodo.value,
                id_cliente: cliente.idcliente,
            });
        },

        removeCliente(id) {
            this.$emit('remove-cliente', id);
        },
        addOneToRoute(idcliente) {
            this.$emit('add-clientes', [idcliente]);
        },

        confirmAddAllToRoute() {
            this.$root.confirm({
                message: this.$t('msg-confirm-add-all-route'),
                onConfirm: this.addAllToRoute,
            });
        },
        confirmRemoveAllFromRoute() {
            this.$root.confirm({
                message: this.$t('msg-confirm-remove-all-route'),
                onConfirm: this.removeAllFromRoute,
            });
        },
        addAllToRoute() {
            this.$emit('add-all-clientes');
        },
        removeAllFromRoute() {
            this.$emit('remove-all-clientes');
        },

        confirmCleanFilters() {
            if (this.possuiFiltroSelecionado()) {
                this.$root.confirm({
                    message: this.$t('msg-confirm-limpar-filtros'),
                    onConfirm: this.limparFiltros,
                });
            }
        },

        pesquisar() {
            this.$emit('carregar-clientes', this.pagination);
        },
        updatePagination(value) {
            this.pagination.currentPage = value.currentPage;
            this.pagination.perPage = value.perPage;
            this.pesquisar(this.pagination.currentPage);
        },

        //FILTROS
        limparFiltros() {
            this.pagination.search = '';
            this.updateAtividade([]);
            this.updateSituacao([]);
            this.updateCidade([]);
            this.updateRegiao([]);
            this.$emit('carregar-clientes', this.pagination);
        },
        possuiFiltroSelecionado() {
            return (
                this.atividadesSelecionadas.length > 0 ||
                this.situacoesSelecionadas.length > 0 ||
                this.cidadesSelecionadas.length > 0 ||
                this.regioesSelecionadas.length > 0
            );
        },
        carregarAtividades(searchQuery) {
            this.atividadesLoading = true;
            this.atividadeService
                .findAll(0, 50, searchQuery)
                .then((r) => {
                    this.atividades = r.content;
                })
                .catch((e) => {
                    console.error(
                        `Erro ao realizar pesquisa de atividades. Termo: [${searchQuery}]`,
                        e
                    );
                })
                .finally((_) => {
                    this.atividadesLoading = false;
                });
        },
        updateAtividade(atividadesSelecionadas) {
            this.atividadesSelecionadas = atividadesSelecionadas;
            this.$emit('update-filtro', {
                nomeFiltro: 'atividades',
                valor: this.atividadesSelecionadas.map((e) => e.id),
            });
        },
        carregarSituacoes(searchQuery) {
            this.situacoesLoading = true;
            this.situacaoService
                .findAllVendas(this.column, this.ordem, 0, 50, 1, searchQuery)
                .then((r) => {
                    this.situacoes = r.content;
                })
                .catch((e) => {
                    console.error(
                        `Erro ao realizar pesquisa de situacoes. Termo: [${searchQuery}]`,
                        e
                    );
                })
                .finally((_) => {
                    this.situacoesLoading = false;
                });
        },
        updateSituacao(situacoesSelecionadas) {
            this.situacoesSelecionadas = situacoesSelecionadas;
            this.$emit('update-filtro', {
                nomeFiltro: 'situacoes',
                valor: this.situacoesSelecionadas.map((e) => e.idsituacao),
            });
        },
        carregarCidades(searchQuery) {
            this.cidadesLoading = true;
            this.cidadeService
                .findAll(0, 50, searchQuery)
                .then((r) => {
                    this.cidades = r.content;
                })
                .catch((e) => {
                    console.error(
                        `Erro ao realizar pesquisa de cidades. Termo: [${searchQuery}]`,
                        e
                    );
                })
                .finally((_) => {
                    this.cidadesLoading = false;
                });
        },
        updateCidade(cidadeSelecionada) {
            this.cidadesSelecionadas = cidadeSelecionada;
            this.$emit('update-filtro', {
                nomeFiltro: 'cidades',
                valor: this.cidadesSelecionadas.map((e) => e.id),
            });
        },
        carregarRegioes(searchQuery) {
            this.regioesLoading = true;
            this.regiaoService
                .findAllCombo(searchQuery)
                .then((r) => {
                    this.regioes = r.content;
                })
                .catch((e) => {
                    console.error(
                        `Erro ao realizar pesquisa de cidades. Termo: [${searchQuery}]`,
                        e
                    );
                })
                .finally((_) => {
                    this.regioesLoading = false;
                });
        },
        updateRegiao(e) {
            this.regioesSelecionadas = e;
            this.$emit('update-filtro', {
                nomeFiltro: 'regioes',
                valor: this.regioesSelecionadas.map((e2) => e2.id),
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.card {
    overflow: initial;
    color: $darker-gray-color;
    .card-header-title {
        color: $darker-gray-color;
        justify-content: space-between;
        padding: 0.3rem;
    }
    .card-content {
        padding-top: 0px;
        padding-left: 0.75rem;
        padding-right: 0.75rem;
        padding-bottom: 0.75rem;
        margin: 0px;
        .card-content-section {
            padding: 0px;
            margin-top: 0.75rem;
            margin-bottom: 0px;
            margin-left: 0px;
            margin-right: 0px;
        }
    }
    .filtro {
        padding: 0.25rem;
        min-height: 40px;
    }
}

.filtro-header {
    display: flex;
    align-items: center;
}

.filtros-extras {
    font-size: 12px;
}
</style>
